import React, { useEffect, useState, useRef } from "react";
import Navbar from "../components/Navbar.js";
import Footer from "../components/Footer.js";
import BannerImage from "../components/img/cardiology-banner.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronRight } from "@fortawesome/free-solid-svg-icons";
import axios from 'axios';
import "../styles/pages.css";
import { FaChevronRight, FaCircleArrowRight } from "react-icons/fa6";
import { useNavigate } from 'react-router-dom';

function Cardiology() {
  const [activeSection, setActiveSection] = useState("overview");
  const [isFixed, setIsFixed] = useState(false);
  const sectionsRef = {
    overview: useRef(null),
    treatment: useRef(null),
    facilities: useRef(null),
    doctors: useRef(null),
  };
  const sidebarRef = useRef(null);
  const contentRef = useRef(null);
  const footerRef = useRef(null);

  const handleScroll = () => {
    const sections = ["overview", "treatment", "facilities", "doctors"];
    let currentSection = "";
    let setFix = false;
    for (let section of sections) {
      const ref = sectionsRef[section].current;
      const { top, bottom } = ref.getBoundingClientRect();
      const isInView =
        top <= window.innerHeight / 2 && bottom >= window.innerHeight / 2;
      if (top < 85) {
        setFix = true;
      } else {
        setFix = false;
      }
      if (isInView) {
        console.log("top", top, "bottom", bottom, "win", window.innerHeight);
        currentSection = section;
      }
    }
    setIsFixed(setFix);
    setActiveSection(currentSection);
  };

  // const scrollToSection = (section) => {
  //   sectionsRef[section].current.scrollIntoView({ behavior: "smooth",block:"center" });
  // };

  const scrollToSection = (section) => {
    const sectionElement = sectionsRef[section].current;
    if (sectionElement) {
      const offsetTop = sectionElement.getBoundingClientRect().top + window.scrollY;
      const headerOffset = 100; // Adjust this value to match the height of your fixed header or sidebar
      window.scrollTo({
        top: offsetTop - headerOffset,
        behavior: "smooth",
      });
    }
  };


  useEffect(() => {
    handleScroll(); // Trigger once on load
    window.addEventListener("scroll", handleScroll);
  }, []);

  const [doctors, setDoctors] = useState([]);

  useEffect(() => {
    const fetchDoctors = async () => {
      try {
        const response = await axios.get(`https://caritasmathahospital.com/wp-content/themes/my_react_theme/api/get_doctors.php?department=Cardiology`);
        setDoctors(response.data);
      } catch (error) {
        console.error("Error fetching doctors:", error);
      }
    };
    fetchDoctors();
  }, []);
  

  const navigate = useNavigate();

  const handleDoctorClick = (doctor) => {
    navigate(`/doctor/${doctor.id}`, { state: { doctor } })
  };

  return (
    <div>

      <Navbar />

      <section className="page-section">
          <div className="section-content">
                <p className='page-heading'>Cardiology Department</p>

                <p className="page-subtitle">
                    Comprehensive Heart Care with Modern Treatments for Cardiovascular Health
                </p>

              
                <div className="page-box">
                    <div className="box-content">
                            <p>  
                                At Caritas Matha Hospital, the Cardiology Department provides expert care for heart conditions, 
                                both in prevention and in advanced treatment. We are equipped to handle many different heart problems using state-of-the-art equipment and skilled cardiologists.  
                                We make it our priority to care for patient's hearts now and promote good health for the future.
                            </p>
                    </div>
                    <div className="box-image">
                        <img src={BannerImage} alt="Dermatology Banner"/>
                    </div>
                </div>
            </div>
        </section>
      <section className="dept-section">
        <div
          ref={sidebarRef}
          className={`sidebar-title ${!isFixed ? "fixed" : ""}`}
        >
          {["overview", "treatment", "facilities", "doctors"].map((section) => (
            <p
              key={section}
              className={`title ${activeSection === section ? "active" : ""}`}
              onClick={() => scrollToSection(section)}
            >
              {section.charAt(0).toUpperCase() + section.slice(1)}
              {activeSection === section && (
                <FontAwesomeIcon
                  icon={faChevronRight}
                  className="chevron-icon"
                />
              )}
            </p>
          ))}
        </div>
        <div ref={contentRef} className="contents">
          <div ref={sectionsRef.overview} className="overview-content">
            <p className="content-heading">Overview</p>
            {/* Overview content here */}
                <p>Our Cardiology Department in Caritas Matha Hospital always works to maintain the heart of the patients in a healthy way and treat any problems when they occur. From first tests to new treatments, we always deliver care carefully and with deep compassion. Our expert team always ensures that every heartbeat receives the care it needs, whether it is a normal check-up or an urgent case.</p>
          </div>
          <div ref={sectionsRef.treatment} className="treatment-content">
            <p className="content-heading">Treatment</p>
            {/* Treatment content here */}

            <ul>
                <li><span className="subtitle">Heart Screenings : </span>Early detection of heart diseases with detailed tests for cholesterol, blood pressure, and ECG.</li>
                <br/>
                <li><span className="subtitle">Interventional Cardiology: </span>Angioplasty and stent placement are the simpler procedures that are used to keep blood running smoothly.</li>
                <br/>
                <li><span className="subtitle">Heart Attack Management: </span>A swift, skilled assistance is always given whenever there is a heart attack emergency.</li>
                <br/>
                <li><span className="subtitle">Heart Rhythm Care: </span>Arrhythmia problems can be assessed and fixed by using pacemakers, ablation therapy, and careful monitoring.</li>
                <br/>
                <li><span className="subtitle">Heart Failure Support: </span>Ongoing treatment plans that can help patients who have heart failure to live better and longer.</li>
                <br/>
                <li><span className="subtitle">Preventive Cardiology : </span>Advice on healthy living, medicine choices, and screening to help you avoid heart problems.</li>
                <br/>
            </ul>
          </div>
          <div ref={sectionsRef.facilities} className="facilities-content">
            <p className="content-heading">Facilities</p>
            {/* Facilities content here */}
            <ul>
                <li><span className="subtitle">24/7 Cardiac Emergency Services: </span>Our team is ready at all times to treat serious heart problems effectively.</li>
                <br/>

                <li><span className="subtitle">Cardiac Catheterization Lab: </span>Advanced imaging and treatments that do not require open surgery.</li>
                <br/>

                <li><span className="subtitle">Non-Invasive Cardiac Testing: </span>ECG, Echo, stress tests, and Holter monitoring to help with precise diagnosis.</li>
                <br/>


                <li><span className="subtitle">Dedicated Cardiac ICU: </span>Critical care is always available for patients with serious heart diseases.</li>
                <br/>

                <li><span className="subtitle">Team of Expert Cardiologists: </span>Experienced cardiologists with trained nurses and technicians.</li>
                <br/>

                <li><span className="subtitle">Rehabilitation and Follow-Up: </span>To support long-term heart health and recovery, aftercare will be provided.</li>
                <br/>
            </ul>
          </div>

          <div ref={sectionsRef.doctors} className="doctors">
              <p className="content-heading">Doctors</p>
              {doctors.length > 0 ? (
                <div className='doctorbox-container'>
                    {doctors.map(doctor => (
                      <div key={doctor.id} className="doctorbox">
                          <div className="doctor-box">
                              <img src={doctor.image_url} className='doctor-img' onClick={() => handleDoctorClick(doctor)} style={{ cursor: "pointer" }}/>
                              <div className='doctor-details'>
                                  <h4 onClick={() => handleDoctorClick(doctor)} style={{ cursor: "pointer" }}>{doctor['name']}</h4>
                                  <p>{doctor['designation']}</p>
                                  <p>{ doctor.available_time }</p>
                                  <br/>
                                  {parseInt(doctor.appointment_enabled) === 1 && (
                                      <p>
                                          <a href="https://booking.caritasmathahospital.com/OnlineAppointmentBooking/OnlineAppointmentBooking.aspx" target="_blank" rel="noopener noreferrer" >
                                              Book An Appointment <FaChevronRight />
                                          </a>
                                      </p>
                                  )}
                              </div>
                          </div>
                          <div className='arrow-section'>
                              <FaCircleArrowRight className='right-circle-arrow' onClick={() => handleDoctorClick(doctor)} style={{ cursor: "pointer" }}/>
                          </div>
                      </div>
                    ))}
                </div>
              ) : (
                  <p>No doctors available in this department.</p>
              )}
          </div>
        </div>
      </section>
      <Footer ref={footerRef} />
    </div>
  );
}

export default Cardiology;